import { useNavigate, useParams } from "react-router-dom";
import TaskDrawer from "../../components/TaskDrawer";

export default function MyTaskDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <TaskDrawer
      taskId={id}
      role="employee"
      onClose={() => navigate("/me")}
      onChanged={() => {}}
    />
  );
}
